import React from 'react'
import Navbar from './Navbar'

const Buy = () => {
  return (
    <>
    <Navbar/>
    <div>
        Buy page Comming Soon....
    </div>
    </>
  )
}

export default Buy
